import type { EstimateStatus } from './types';

/**
 * Derived Expired state (D3): an estimate is "Expired" purely for display when it
 * is still Sent and its validity window has passed. Never stored server-side.
 */
export function isExpired(status: EstimateStatus, expiresAtUtc: string | null): boolean {
  return status === 'Sent' && expiresAtUtc != null && new Date(expiresAtUtc) < new Date();
}
